import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    language: 'KR'
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        initialize: state => initialState,
        changeField: (state, { payload: { key, value }}) => {
            state[key] = value;
        }
    },
});

export const { initialize, changeField } = languageSlice.actions;
export default languageSlice.reducer;
